export default "__VITE_ASSET__CkgK9EBB__"